enum YellowLightCategoryType {
  SKILLS = "Skills",
  LICENSE = "Licenses",
  CERTIFICATIONS = "Certifications",
  EDUCATION = "Education",
  SALARY = "Salary",
  OCCUPATION = "Occupation",
  LANGUAGES = "Languages",
  WORK_EXPERIENCE = "Work Experience",
  UNSORTED = "Unsorted",
  HIDDEN = "Hidden",
  MERGED = "Merged",
}

// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
const PARENT_TYPE_MAP: Map<string, YellowLightCategoryType> = new Map()
  .set("administrative_customer_service_skills", YellowLightCategoryType.SKILLS)
  .set("agriculture_grounds_maintenance_skills", YellowLightCategoryType.SKILLS)
  .set("animal_care_handling_skills", YellowLightCategoryType.SKILLS)
  .set("architecture_engineering_skills", YellowLightCategoryType.SKILLS)
  .set("beauty_skincare_skills", YellowLightCategoryType.SKILLS)
  .set("caregiving_skills", YellowLightCategoryType.SKILLS)
  .set("cleaning_sanitation_skills", YellowLightCategoryType.SKILLS)
  .set("construction_manufacturing_skills", YellowLightCategoryType.SKILLS)
  .set("corporate_strategy_development_skills", YellowLightCategoryType.SKILLS)
  .set("data_analysis_visualization_skills", YellowLightCategoryType.SKILLS)
  .set("databases", YellowLightCategoryType.SKILLS)
  .set("education_instruction_skills", YellowLightCategoryType.SKILLS)
  .set("electrical_mechanical_systems_technology_skills", YellowLightCategoryType.SKILLS)
  .set("finance_accounting_skills", YellowLightCategoryType.SKILLS)
  .set("food_preparation_service_skills", YellowLightCategoryType.SKILLS)
  .set("healthcare_skills", YellowLightCategoryType.SKILLS)
  .set("heavy_equipment_machinery_skills", YellowLightCategoryType.SKILLS)
  .set("human_resources_skills", YellowLightCategoryType.SKILLS)
  .set("it_software_development_skills", YellowLightCategoryType.SKILLS)
  .set("information_management_skills", YellowLightCategoryType.SKILLS)
  .set("laboratory_skills", YellowLightCategoryType.SKILLS)
  .set("leadership_management_skills", YellowLightCategoryType.SKILLS)
  .set("legal_knowledge_experience", YellowLightCategoryType.SKILLS)
  .set("logistics_operations_management_skills", YellowLightCategoryType.SKILLS)
  .set("marketing_public_relations_skills", YellowLightCategoryType.SKILLS)
  .set("material_moving_skills", YellowLightCategoryType.SKILLS)
  .set("measuring_instruments", YellowLightCategoryType.SKILLS)
  .set("media_arts_design_skills", YellowLightCategoryType.SKILLS)
  .set("medical_specialties", YellowLightCategoryType.SKILLS)
  .set("military_protective_intelligence_skills", YellowLightCategoryType.SKILLS)
  .set("network_server_technology", YellowLightCategoryType.SKILLS)
  .set("operating_systems", YellowLightCategoryType.SKILLS)
  .set("programming_languages_frameworks", YellowLightCategoryType.SKILLS)
  .set("project_program_process_management_skills", YellowLightCategoryType.SKILLS)
  .set("quality_processes", YellowLightCategoryType.SKILLS)
  .set("regulations_standards", YellowLightCategoryType.SKILLS)
  .set("research_skills", YellowLightCategoryType.SKILLS)
  .set("retail_hospitality_skills", YellowLightCategoryType.SKILLS)
  .set("sales_skills", YellowLightCategoryType.SKILLS)
  .set("social_services_counseling_skills", YellowLightCategoryType.SKILLS)
  .set("software_programs", YellowLightCategoryType.SKILLS)
  .set("sports_physical_fitness_skills", YellowLightCategoryType.SKILLS)
  .set("vehicle_design_manufacturing_repair_skills", YellowLightCategoryType.SKILLS)
  .set("vehicle_operation_skills", YellowLightCategoryType.SKILLS)
  .set("writing_editing_communication_skills", YellowLightCategoryType.SKILLS)
  .set("education_levels", YellowLightCategoryType.EDUCATION)
  .set("field_of_study", YellowLightCategoryType.EDUCATION)
  .set("scholastic_credentials", YellowLightCategoryType.EDUCATION)
  .set("technology", YellowLightCategoryType.SKILLS)
  .set("certifications", YellowLightCategoryType.CERTIFICATIONS)
  .set("government_security_clearances", YellowLightCategoryType.LICENSE)
  .set("licenses", YellowLightCategoryType.LICENSE)
  .set("language_skill", YellowLightCategoryType.LANGUAGES)
  .set("language_proficiency", YellowLightCategoryType.LANGUAGES)
  .set("spoken_language", YellowLightCategoryType.LANGUAGES)
  .set("spoken_written_signed_languages", YellowLightCategoryType.LANGUAGES)
  .set("preemployment_conditions", YellowLightCategoryType.HIDDEN);

export const getCategoryTypeIdFromRawType = (
  rawType?: string,
): YellowLightCategoryType | "" | undefined => {
  return rawType && PARENT_TYPE_MAP.get((rawType || "").split("/")[0]);
};

export default YellowLightCategoryType;
